import { init, addMessages, getLocaleFromNavigator } from 'svelte-i18n';
import en from "locales/en.json";
import it from "locales/it.json";

import "./scss/main.scss";
import App from "./svelte/App.svelte";

import config from 'config';

function bootstrap() {
	initLocale(config.locale);

	let targets = document.querySelectorAll('[data-scope="panel-configurator"]');
	targets.forEach(target => {
		new App({ target, props: { config } });
	});
}

function initLocale(locale) {
	addMessages('en', en);
	addMessages('it', it);
	init({
		fallbackLocale: 'en',
		initialLocale: locale.replace('_', '-') || getLocaleFromNavigator(),
	});
}

window.addEventListener('DOMContentLoaded', bootstrap);